import React, { useState, useEffect } from "react";
import { db, collection, getDocs, fmt } from "../config/firebase";
import "./NewArrivals.css";

const NewArrivals = ({ onSelectProduct }) => {
  const [newProducts, setNewProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNewArrivals();
  }, []);

  const fetchNewArrivals = async () => {
    try {
      const snap = await getDocs(collection(db, "products"));
      const items = [];
      snap.forEach((docSnap) => {
        const data = docSnap.data();
        if (data.isNewArrival) {
          items.push({ id: docSnap.id, ...data });
        }
      });
      setNewProducts(items);
    } catch (err) {
      console.error("Error fetching new arrivals:", err);
    } finally {
      setLoading(false);
    }
  };

  // Effective current price: first variant's price if variants exist, else base price
  const getEffectivePrice = (product) => {
    if (product.variants && product.variants.length > 0) {
      return product.variants[0].price;
    }
    return product.price;
  };

  // Effective original/MRP price for the same "effective" item (variant[0] or base)
  const getEffectiveOriginalPrice = (product, currentPrice) => {
    let original = null;

    if (product.variants && product.variants.length > 0) {
      if (product.variants[0].originalPrice) {
        original = Number(product.variants[0].originalPrice);
      }
    }

    if (!original) {
      original = Number(product.originalPrice);
    }

    if (!original || isNaN(original) || original <= currentPrice) return null;
    return original;
  };

  const getDiscountPercent = (original, current) => {
    if (!original || !current || original <= current) return 0;
    return Math.round(((original - current) / original) * 100);
  };

  // Don't render anything if there are no new arrivals — no empty box
  if (loading || newProducts.length === 0) return null;

  return (
    <section className="new-arrivals-section">
      <div className="new-arrivals-container">
        <div className="new-arrivals-header">
          <span className="new-arrivals-badge">✨ Just In</span>
          <h2 className="new-arrivals-title">New Arrivals</h2>
        </div>
        <div className="new-arrivals-strip">
          {newProducts.map((product) => {
            const currentPrice = getEffectivePrice(product);
            const originalPrice = getEffectiveOriginalPrice(product, currentPrice);
            const discountPercent = originalPrice ? getDiscountPercent(originalPrice, currentPrice) : 0;

            return (
              <button
                key={product.id}
                className="new-arrival-card"
                onClick={() => onSelectProduct(product)}
              >
                <div className="new-arrival-img-wrapper">
                  <img
                    src={product.image || "https://picsum.photos/300/300"}
                    alt={product.name}
                    onError={(e) => { e.target.src = "https://picsum.photos/300/300"; }}
                  />
                  <span className="new-arrival-tag">NEW</span>
                  {discountPercent > 0 && (
                    <span className="new-arrival-discount">{discountPercent}% OFF</span>
                  )}
                </div>
                <div className="new-arrival-info">
                  <span className="new-arrival-name">{product.name}</span>
                  <div className="new-arrival-price-row">
                    {originalPrice && (
                      <span className="new-arrival-price-original">{fmt(originalPrice)}</span>
                    )}
                    <span className="new-arrival-price">{fmt(currentPrice)}</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;